import { CombinedFilterDropdown } from './combined-filter-dropdown.component';
import { jsx as _jsx } from "react/jsx-runtime";
export var ClassStatusFilter = function ClassStatusFilter(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      _ref$labels = _ref.labels,
      labels = _ref$labels === void 0 ? {
    active: 'Active',
    archived: 'Archived',
    status: 'Class status'
  } : _ref$labels;
  return /*#__PURE__*/_jsx(CombinedFilterDropdown, {
    typeOptions: [],
    statusOptions: [{
      id: 'ACTIVE',
      label: labels.active
    }, {
      id: 'ARCHIVED',
      label: labels.archived
    }],
    selectedTypes: [],
    selectedStatuses: [value],
    onTypeChange: function onTypeChange() {
      return undefined;
    },
    onStatusChange: function onStatusChange(statuses) {
      return onChange(statuses[0]);
    },
    onClearAll: function onClearAll() {
      return onChange('ACTIVE');
    },
    singleStatus: true,
    showAllStatuses: false,
    labels: {
      typeSection: '',
      allTypes: '',
      statusSection: labels.status,
      allStatuses: ''
    }
  });
};